<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">
    <div class="l-row">
      <form-group v-if="colors.length" :label="$t(`color.label`)" :columns="3" :error="getError('color', variation.sku)" :required="true">
        <multiselect v-model="color" :options="colors" track-by="code" label="label" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção" :disabled="disabledInputs()">
        </multiselect>
      </form-group>

      <form-group v-if="sizes.length" :label="$t(`size.label`)" :columns="3" :error="getError('size', variation.sku)" :required="true">
        <multiselect v-model="size" :options="sizes" track-by="code" label="label" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção" :disabled="disabledInputs()">
        </multiselect>
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      sizes: [],
      colors: [],
      size: null,
      color: null
    }),
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      this.loading = true

      this.loading = false
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?f918ce5a